// extracted by mini-css-extract-plugin
export default {"wrapper":"iframed__wrapper__DCVnI","frameContainer":"iframed__frameContainer__juVbG"};